import firebase from "firebase/app";
import "firebase/auth";
import "firebase/storage";
import "firebase/firestore";
import "firebase/analytics";

const firebaseConfig = {
  apiKey: "AIzaSyB6Jqn_BDha1cDrdaG3FXEdIA7wbjlFYq0",
  authDomain: "minnano-takeout.firebaseapp.com",
  databaseURL: "https://minnano-takeout.firebaseio.com",
  projectId: "minnano-takeout",
  storageBucket: "minnano-takeout.appspot.com",
  messagingSenderId: "65923120711",
  appId: "1:65923120711:web:4e803797f5268f88c87b62",
  measurementId: "G-TKME9VHGMQ",
};
firebase.initializeApp(firebaseConfig);
firebase.analytics();

export default firebase;
